export default __webpack_public_path__ + "static/media/solution_75.19250d05.svg";